import { LogOut } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Signs out with a real form post, so the page fully reloads and no
 * signed-in state lingers in the Inertia client. `variant="icon"` for
 * the compact account row in sidebars, `"full"` for a labelled button.
 */
export default function SignOutButton({ variant = "icon", className }) {
  const token = typeof document !== "undefined" ? document.querySelector('meta[name="csrf-token"]')?.content || "" : "";

  return (
    <form method="POST" action="/sign_out" className={cn("shrink-0", className)}>
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={token} />
      {variant === "icon" ? (
        <button
          type="submit"
          aria-label="Sign out"
          title="Sign out"
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-secondary/60 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <LogOut className="h-4 w-4" />
        </button>
      ) : (
        <button
          type="submit"
          className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-secondary/60 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      )}
    </form>
  );
}
